// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/authorization/v1/policy_api.proto (package ai.h2o.authorization.v1, syntax proto3)
/* eslint-disable */

import type { Policy } from "./policy_pb";
import { RPC } from "../../../../runtime";

/**
 * @generated from message ai.h2o.authorization.v1.GetPolicyRequest
 */
export type GetPolicyRequest = {
/**
 * Policy name, e.g. "Policies/<UUID>".
 *
 * @generated from field: string name = 1;
 */
name?: string;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.GetPolicyResponse
 */
export type GetPolicyResponse = {
/**
 * @generated from field: ai.h2o.authorization.v1.Policy policy = 1;
 */
policy?: Policy;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.CreatePolicyRequest
 */
export type CreatePolicyRequest = {
/**
 * @generated from field: ai.h2o.authorization.v1.Policy policy = 1;
 */
policy?: Policy;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.CreatePolicyResponse
 */
export type CreatePolicyResponse = {
/**
 * @generated from field: ai.h2o.authorization.v1.Policy policy = 1;
 */
policy?: Policy;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.UpdatePolicyRequest
 */
export type UpdatePolicyRequest = {
/**
 * @generated from field: ai.h2o.authorization.v1.Policy policy = 1;
 */
policy?: Policy;
/**
 * Only the fields specified in update_mask will be updated.
 *
 * @generated from field: google.protobuf.FieldMask update_mask = 2;
 */
updateMask?: string;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.UpdatePolicyResponse
 */
export type UpdatePolicyResponse = {
/**
 * @generated from field: ai.h2o.authorization.v1.Policy policy = 1;
 */
policy?: Policy;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.DeletePolicyRequest
 */
export type DeletePolicyRequest = {
/**
 * @generated from field: string name = 1;
 */
name?: string;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.DeletePolicyResponse
 */
export type DeletePolicyResponse = {
}
;
/**
 * @generated from message ai.h2o.authorization.v1.ListPoliciesRequest
 */
export type ListPoliciesRequest = {
/**
 * Maximum number of items server should return in the response. When set to 0
 * server will decide how many items to return.
 * Server can decide to return more or less items then specified.
 *
 * @generated from field: int32 page_size = 1;
 */
pageSize?: number;
/**
 * Use value returned in next_page_token to retrieve next page of results.
 *
 * @generated from field: string page_token = 2;
 */
pageToken?: string;
}
;
/**
 * @generated from message ai.h2o.authorization.v1.ListPoliciesResponse
 */
export type ListPoliciesResponse = {
/**
 * @generated from field: repeated ai.h2o.authorization.v1.Policy policies = 1;
 */
policies?: Policy[];
/**
 * When not empty server has more results then returned. Use this value as
 * the page_token in the ListRolesRequest to obtain next page of results.
 *
 * @generated from field: string next_page_token = 2;
 */
nextPageToken?: string;
}
;
/**
 * Returns details of the policy specified by the name.
 *
 * Authorized by the "actions/policyserver/policies/READ" action on the
 * "//policyserver" resource.
 *
 * Authorization can be bypassed when authorization bypass feature is enabled.
 *
 * @generated from rpc ai.h2o.authorization.v1.PolicyService.GetPolicy
 */
export const PolicyService_GetPolicy = new RPC<GetPolicyRequest,GetPolicyResponse>("GET", "/v1/{name=policies/*}");
/**
 * Creates a new policy.
 *
 * Authorized by the "actions/policyserver/policies/CREATE" action on the
 * "//policyserver" resource.
 *
 * Authorization can be bypassed when authorization bypass feature is enabled.
 *
 * @generated from rpc ai.h2o.authorization.v1.PolicyService.CreatePolicy
 */
export const PolicyService_CreatePolicy = new RPC<CreatePolicyRequest,CreatePolicyResponse>("POST", "/v1/policies", "policy");
/**
 * Updates the policy specified by the name.
 *
 * Authorized by the "actions/policyserver/policies/UPDATE" action on the
 * "//policyserver" resource.
 *
 * Authorization can be bypassed when authorization bypass feature is enabled.
 *
 * @generated from rpc ai.h2o.authorization.v1.PolicyService.UpdatePolicy
 */
export const PolicyService_UpdatePolicy = new RPC<UpdatePolicyRequest,UpdatePolicyResponse>("PATCH", "/v1/{policy.name=policies/*}", "policy");
/**
 * Deletes the policy specified by the name.
 *
 * Authorized by the "actions/policyserver/policies/DELETE" action on the
 * "//policyserver" resource.
 *
 * Authorization can be bypassed when authorization bypass feature is enabled.
 *
 * @generated from rpc ai.h2o.authorization.v1.PolicyService.DeletePolicy
 */
export const PolicyService_DeletePolicy = new RPC<DeletePolicyRequest,DeletePolicyResponse>("DELETE", "/v1/{name=policies/*}");
/**
 * Lists all policies.
 *
 * Authorized by the "actions/policyserver/policies/READ" action on the
 * "//policyserver" resource.
 *
 * Authorization can be bypassed when authorization bypass feature is enabled.
 *
 * @generated from rpc ai.h2o.authorization.v1.PolicyService.ListPolicies
 */
export const PolicyService_ListPolicies = new RPC<ListPoliciesRequest,ListPoliciesResponse>("GET", "/v1/policies");
